import React from 'react'
import { components, OptionProps, SingleValueProps } from 'react-select'
import { isInactiveAccountStatus } from './TotalUsers/AccountStatusFilter'

export type InactiveSelectOption = {
  label: string
  value: string
  isInactive?: boolean
  isArchived?: boolean
}

export const ArchivedManagerBadge = () => (
  <span style={{
    marginLeft: 8,
    padding: '3px 9px',
    borderRadius: 12,
    background: '#e8ecec',
    color: 'var(--color-text-secondary)',
    fontSize: 12,
    lineHeight: '18px',
    flexShrink: 0,
  }}>Archived</span>
)

export const ManagerSingleValue = (props: SingleValueProps<InactiveSelectOption>) => (
  <components.SingleValue {...props}>
    <span style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
      <span title={props.data.label} style={{ flex: 1, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{props.children}</span>
    </span>
  </components.SingleValue>
)

const inactiveTagStyle: React.CSSProperties = {
  marginLeft: 8,
  fontSize: 9,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'rgba(236, 94, 123, 1)',
  background: 'rgba(255, 242, 242, 1)',
  padding: '2px 8px',
  borderRadius: 4,
  lineHeight: '100%',
  width: '41px',
  height: '18px',
  flexShrink: 0,
}

export const InactiveTagOption = (props: OptionProps<InactiveSelectOption, false> & { truncate?: boolean }): JSX.Element => {
  const { data } = props

  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span title={props.label} style={{
          whiteSpace: props.truncate ? 'nowrap' : 'normal',
          wordWrap: 'break-word',
          textOverflow: props.truncate ? 'ellipsis' : undefined,
          minWidth: 0,
          overflow: 'hidden',
          flex: 1,
        }}>
          {props.label}
        </span>
        {data?.isArchived ? <ArchivedManagerBadge />
          : data?.isInactive ? <span style={inactiveTagStyle}>Inactive</span> : null}
      </div>
    </components.Option>
  )
}

export const QcsManagerOption = (props: OptionProps<InactiveSelectOption, false>) => (
  <InactiveTagOption {...props} truncate />
)

export const mapManagerSelectOptions = (managers: {
  id: number
  name: string
  userStatus?: string
  archived?: boolean
  archivedStatus?: string
}[], includeArchived = false): InactiveSelectOption[] => [
  { label: 'All Managers', value: '', isInactive: false },
  ...managers.map(manager => ({
    label: manager.name,
    value: String(manager.id),
    isInactive: isInactiveAccountStatus(manager.userStatus),
    isArchived: includeArchived && (manager.archived ?? manager.archivedStatus === 'ARCHIVED'),
  })),
]
